module.exports = __webpack_public_path__ + "60b80bb346e2aced0aeaf00a0c0a8378.js";